/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Gsoa_CustomerProfile_FoundReceipts } from '../models/Gsoa_CustomerProfile_FoundReceipts';
import type { Gsoa_CustomerProfile_PosSystemType } from '../models/Gsoa_CustomerProfile_PosSystemType';
import type { Gsoa_CustomerProfile_ReceiptEmailParams } from '../models/Gsoa_CustomerProfile_ReceiptEmailParams';
import type { Gsoa_CustomerProfile_ReceiptPlace } from '../models/Gsoa_CustomerProfile_ReceiptPlace';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GsoaReceiptsService {
    /**
     * Retrieves receipts.
     * @returns Gsoa_CustomerProfile_FoundReceipts Receipts were retrieved.
     * @throws ApiError
     */
    public static getMyReceipts({
        apiVersion = 1,
        branch,
        dateFrom,
        dateTo,
        totalFrom,
        totalTo,
        posSystem,
        place,
        pageNumber = 1,
        pageSize = 10,
        includeGlobusOnline = false,
    }: {
        apiVersion?: number,
        /**
         * House, or comma separated houses.
         */
        branch?: string,
        /**
         * Date from.
         */
        dateFrom?: string,
        /**
         * Date to.
         */
        dateTo?: string,
        /**
         * Total from.
         */
        totalFrom?: number,
        /**
         * Total to.
         */
        totalTo?: number,
        /**
         * Type of POS system (1 = Main, 2 = Gastro, 3 = Petrol).
         */
        posSystem?: Gsoa_CustomerProfile_PosSystemType,
        /**
         * Place where the receipt was issued (1 = Other, 2 = Gastro, 3 = Petrol, 4 = GlobusOnline).
         */
        place?: Gsoa_CustomerProfile_ReceiptPlace,
        /**
         * Page number.
         */
        pageNumber?: number,
        /**
         * Page size.
         */
        pageSize?: number,
        /**
         * Indicates whether to include Globus Online receipts.
         */
        includeGlobusOnline?: boolean,
    }): CancelablePromise<Gsoa_CustomerProfile_FoundReceipts> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/customer/receipts',
            path: {
                'apiVersion': apiVersion,
            },
            query: {
                'branch': branch,
                'dateFrom': dateFrom,
                'dateTo': dateTo,
                'totalFrom': totalFrom,
                'totalTo': totalTo,
                'posSystem': posSystem,
                'place': place,
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'includeGlobusOnline': includeGlobusOnline,
            },
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Retrieves PDF receipt.
     * @returns binary Receipt was found.
     * @throws ApiError
     */
    public static getPdfReceipt({
        id,
        apiVersion = 1,
    }: {
        /**
         * Receipt ID.
         */
        id: string,
        apiVersion?: number,
    }): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/customer/receipts/{id}/pdf',
            path: {
                'apiVersion': apiVersion,
                'id': id,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Retrieves PDF for Globus online order.
     * @returns binary Receipt was found.
     * @throws ApiError
     */
    public static getPdfInvoice({
        orderId,
        apiVersion = 1,
        accept = 'application/pdf',
    }: {
        /**
         * Receipt order ID.
         */
        orderId: string,
        apiVersion?: number,
        accept?: string,
    }): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/customer/invoices/{orderId}',
            path: {
                'apiVersion': apiVersion,
                'orderId': orderId,
            },
            headers: {
                'Accept': accept,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Retrieves PNG receipt.
     * @returns binary Receipt was found.
     * @throws ApiError
     */
    public static getPngReceipt({
        id,
        width,
        border,
        apiVersion = 1,
    }: {
        /**
         * Receipt ID.
         */
        id: string,
        /**
         * Total width of the image in pixels.
         */
        width: number,
        /**
         * Image border width in pixels.
         */
        border: number,
        apiVersion?: number,
    }): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/customer/receipts/{id}/png/{width}-{border}',
            path: {
                'apiVersion': apiVersion,
                'id': id,
                'width': width,
                'border': border,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Sends receipt by e-mail.
     * @returns void
     * @throws ApiError
     */
    public static sendReceiptByEmail({
        id,
        apiVersion = 1,
        requestBody,
    }: {
        /**
         * Receipt ID.
         */
        id: string,
        apiVersion?: number,
        /**
         * Request parameters.
         */
        requestBody?: Gsoa_CustomerProfile_ReceiptEmailParams,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v{apiVersion}/gsoa/customer/receipts/{id}/send-email',
            path: {
                'apiVersion': apiVersion,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
}
